let customAmountTimeout = null;

function productMove() {
    $('.product').each(function () {
        const $product = $(this);

        if (!$product.hasClass('productMoveDone')) {
            $product.find('.prices')
                .append($product.find('.availability'))
                .prepend($product.find('.flag-discount .price-standard').clone());

            $product.find('.price-additional').text(
                $product.find('.price-additional').text().replace('včetně', 's')
            );

            $product.find('.image').append(
                $product.find('.flag-discount .price-standard').clone()
            );

            $product.append('<span class="btn_toggle"></span>');
            $product.addClass('productMoveDone');
        }

        renderSingleProductInfo($product);
    });

    $('.pagination__list li').each(function () {
        const $link = $(this).find('a.pagination__link');
        if (!$link.length) return;

        const testId = $link.data('testid');

        if (testId === 'linkPreviousPage') $(this).addClass('prev');
        if (testId === 'linkNextPage') $(this).addClass('next');
    });

    syncCustomCartFormsFromDataLayer();
}

function getProductCodeFromCard($product) {
    let code = $product.attr('data-code');
    if (code) return $.trim(code);

    code = $product.find('[data-micro="sku"]').first().text();
    if (code) return $.trim(code);

    code = $product.find('.p-code, .product-code').first().text();
    if (code) return $.trim(code).replace('Kód:', '').trim();

    return null;
}

function getProductPriceFromCard($product) {
    const selectors = [
        '.price-final strong',
        '.price-final',
        '.price strong',
        '.prices .price-final',
        '.p-final-price-wrapper .price-final'
    ];

    for (const selector of selectors) {
        const text = $product.find(selector).first().text().trim();
        if (text) return parseCustomPrice(text);
    }

    return 0;
}

function renderSingleProductInfo($product) {
    if ($product.hasClass('productPairLoaded')) return;

    const code = getProductCodeFromCard($product);
    if (!code) return;

    $product.addClass('productPairLoaded');

    const unitPrice = getProductPriceFromCard($product);

    $product.find('.p-tools a.btn').first().replaceWith(
        '<span class="customBtnVariant btn btn-cart add-to-cart-button">Do košíku</span>'
    );

    const html = `
        <div class="productPairs" style="display:none;">
            <div class="productPairsList">

                <div class="mobilePackageInfo">
                    <div class="mobilePackageInfoItem" data-package-index="0">
                        <span class="mobilePackageLeft">ks</span>
                        <span class="mobilePackageEqual">=</span>
                        <span class="mobilePackageAmount">1</span>
                        <span class="mobilePackageRight">ks</span>
                    </div>
                </div>

                <div class="commonLine" data-unit="ks" data-package-index="0">
                    <div class="left">
                        <div class="lineIt">ks = 1 ks</div>
                    </div>

                    <div class="right">
                        <form
                            action="${shoptet.config.updateCartUrl}"
                            method="post"
                            class="quantity-form js-quantity-form csrf-enabled customAmountForm"
                            data-code="${escapeHtmlAttribute(code)}"
                            data-price-id=""
                            data-item-id=""
                            data-unit-price="${unitPrice}"
                            data-current-amount="0"
                        >
                            <input type="hidden" name="itemId" value="">
                            <input type="hidden" name="priceId" value="">

                            <button type="button" class="amountMinus" aria-label="Snížit množství">−</button>

                            <div class="amountInputWrap">
                                <input
                                    type="number"
                                    name="amount"
                                    class="amount amountInput"
                                    value="0"
                                    min="0"
                                    step="1"
                                    autocomplete="off"
                                    inputmode="numeric"
                                    data-decimals="0"
                                >
                                <span class="amountUnit">ks</span>
                            </div>

                            <button type="button" class="amountPlus" aria-label="Zvýšit množství">+</button>
                        </form>
                    </div>
                </div>

                <div class="commnotPriceBottom">
                    <span class="pc">Cena celkem</span>
                    <span class="mobile">Celkem bez DPH</span>:
                    <span class="countPrice">${formatCustomCurrency(0)}</span>
                </div>

            </div>
        </div>
    `;

    $product.find('.p-in').append(html);
}

function escapeHtmlAttribute(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function getCurrentCartItems() {
    if (typeof getShoptetDataLayer !== 'function') return [];

    const cart = getShoptetDataLayer('cart');
    return Array.isArray(cart) ? cart : [];
}

function syncCustomCartFormsFromCartItems(cartItems) {
    if (!Array.isArray(cartItems)) return;

    $('.customAmountForm').each(function () {
        const $form = $(this);
        const code = String($form.data('code') || '').trim();

        const cartItem = cartItems.find(item =>
            String(item.code || '').trim() === code
        );

        if (!cartItem) {
            $form.attr({
                'data-item-id': '',
                'data-price-id': '',
                'data-current-amount': 0
            });

            $form.find('input[name="itemId"]').val('');
            $form.find('input[name="priceId"]').val('');
            $form.find('.amountInput').val(0);

            updateActiveState($form);
            return;
        }

        const quantity = parseInt(cartItem.quantity, 10) || 0;

        $form.attr({
            'data-item-id': cartItem.itemId || '',
            'data-price-id': cartItem.priceId || '',
            'data-current-amount': quantity
        });

        $form.find('input[name="itemId"]').val(cartItem.itemId || '');
        $form.find('input[name="priceId"]').val(cartItem.priceId || '');
        $form.find('.amountInput').val(quantity);

        updateActiveState($form);
    });
}

function syncCustomCartFormsFromDataLayer() {
    syncCustomCartFormsFromCartItems(getCurrentCartItems());
    updateAllActiveStates();
}

function submitCustomAmountForm($form) {
    let displaySpinner = true;

    if (
        shoptet.abilities &&
        shoptet.abilities.feature &&
        !shoptet.abilities.feature.extended_ajax_cart &&
        $('body').hasClass('user-action-visible')
    ) {
        displaySpinner = false;
    }

    shoptet.cart.ajaxSubmitForm(
        shoptet.config.updateCartUrl,
        $form[0],
        'functionsForCart',
        'cart',
        displaySpinner
    );
}

function changeCustomAmount($form, newAmount) {
    const code = String($form.data('code') || '').trim();
    const $product = $form.closest('.product');

    const oldAmount = parseInt($form.attr('data-current-amount'), 10) || 0;
    const itemId = String($form.find('input[name="itemId"]').val() || '').trim();
    const priceId = String($form.find('input[name="priceId"]').val() || '').trim();

    newAmount = parseInt(newAmount, 10);

    if (isNaN(newAmount) || newAmount < 0) {
        newAmount = 0;
    }

    $form.find('.amountInput').val(newAmount);
    $form.attr('data-current-amount', newAmount);

    updateActiveState($form);

    if (newAmount > oldAmount) {
        showCartMessage($product, 'Přidáno do košíku', 'addtocart');
    } else if (newAmount < oldAmount) {
        showCartMessage($product, 'Odebráno z košíku', 'removetocart');
    }

    if (!itemId && newAmount > 0) {
        shoptet.cartShared.addToCart({
            productCode: code,
            amount: newAmount
        }, true);

        delayedCartSync(500);
        return;
    }

    if (!itemId && newAmount <= 0) {
        $form.attr('data-current-amount', 0);
        $form.find('.amountInput').val(0);

        updateActiveState($form);
        return;
    }

    if (itemId && newAmount <= 0) {
        shoptet.cartShared.removeFromCart({ itemId }, true);

        $form.attr({
            'data-item-id': '',
            'data-price-id': '',
            'data-current-amount': 0
        });

        $form.find('input[name="itemId"]').val('');
        $form.find('input[name="priceId"]').val('');
        $form.find('.amountInput').val(0);

        updateActiveState($form);
        delayedCartSync(500);

        return;
    }

    if (!priceId) {
        delayedCartSync(200);
        return;
    }

    submitCustomAmountForm($form);
    delayedCartSync(500);
}

$(document).on('click', '.customAmountForm .amountPlus', function () {
    const $form = $(this).closest('.customAmountForm');
    const amount = parseInt($form.find('.amountInput').val(), 10) || 0;

    changeCustomAmount($form, amount + 1);
});

$(document).on('click', '.customAmountForm .amountMinus', function () {
    const $form = $(this).closest('.customAmountForm');
    const amount = parseInt($form.find('.amountInput').val(), 10) || 0;

    if (amount <= 0) return;

    changeCustomAmount($form, amount - 1);
});

$(document).on('input change', '.customAmountForm .amountInput', function () {
    const $input = $(this);
    const $form = $input.closest('.customAmountForm');

    let value = parseInt($input.val(), 10);

    if (isNaN(value) || value < 0) {
        value = 0;
    }

    $input.val(value);
    updateActiveState($form);

    clearTimeout(customAmountTimeout);

    customAmountTimeout = setTimeout(function () {
        changeCustomAmount($form, value);
    }, 500);
});

function updateActiveState($form) {
    const amount = parseInt($form.find('.amountInput').val(), 10) || 0;
    const $commonLine = $form.closest('.commonLine');
    const $list = $form.closest('.productPairsList');
    const $pairs = $form.closest('.productPairs');
    const packageIndex = $commonLine.attr('data-package-index');

    $commonLine.toggleClass('activeLine', amount > 0);

    if (packageIndex !== undefined) {
        $list
            .find('.mobilePackageInfoItem[data-package-index="' + packageIndex + '"]')
            .toggleClass('activeLine', amount > 0);
    }

    $pairs.toggleClass(
        'hasActiveLine',
        $list.find('.commonLine.activeLine').length > 0
    );

    updateProductPairsTotal($list);
    updateProductPairRemoveIcon($form.closest('.product'));
}

function updateAllActiveStates() {
    $('.customAmountForm').each(function () {
        updateActiveState($(this));
    });

    updateAllProductPairsTotals();
    updateAllProductPairRemoveIcons();

    $('.product').each(function () {
        updateProductPairsVisibility($(this));
    });
}

$('html').on('click', '.customBtnVariant', function () {
    const $product = $(this).closest('.product');

    $product.find('.p-bottom').hide();
    $product.find('.productPairs').slideToggle();
});

function parseCustomPrice(value) {
    if (typeof value === 'number') return value;
    if (!value) return 0;

    return Number(
        String(value)
            .replace(/\u00a0/g, '')
            .replace(/\s/g, '')
            .replace(/Kč/gi, '')
            .replace(/CZK/gi, '')
            .replace(',', '.')
            .replace(/[^\d.]/g, '')
    ) || 0;
}

function formatCustomCurrency(value) {
    value = Number(value) || 0;

    if (typeof value.ShoptetFormatAsCurrency === 'function') {
        return value.ShoptetFormatAsCurrency();
    }

    return value.toLocaleString('cs-CZ') + ' Kč';
}

function updateProductPairsTotal($list) {
    if (!$list.length) return;

    let total = 0;

    $list.find('.customAmountForm').each(function () {
        const $form = $(this);
        const amount = parseInt($form.find('.amountInput').val(), 10) || 0;
        const unitPrice = parseCustomPrice($form.attr('data-unit-price'));

        total += amount * unitPrice;
    });

    $list.find('.commnotPriceBottom').html(
        '<span class="pc">Cena celkem</span> ' +
        '<span class="mobile">Celkem bez DPH</span>: ' +
        '<span class="countPrice">' + formatCustomCurrency(total) + '</span>'
    );
}

function updateAllProductPairsTotals() {
    $('.productPairsList').each(function () {
        updateProductPairsTotal($(this));
    });
}

function updateProductPairRemoveIcon($product) {
    const hasActive = $product
        .find('.productPairs .customAmountForm')
        .filter(function () {
            const amount = parseInt($(this).find('.amountInput').val(), 10) || 0;
            const itemId = $(this).find('input[name="itemId"]').val();

            return amount > 0 && !!itemId;
        }).length > 0;

    const $icon = $product.find('.removeProductPairsGroup');

    if (hasActive) {
        if (!$icon.length) {
            $product.find('.p').append(
                '<span class="removeProductPairsGroup" title="Odebrat z košíku" aria-label="Odebrat z košíku"></span>'
            );
        }

        return;
    }

    $icon.remove();
}

function updateAllProductPairRemoveIcons() {
    $('.product').each(function () {
        updateProductPairRemoveIcon($(this));
    });
}

$(document).on('click', '.removeProductPairsGroup', function (e) {
    e.preventDefault();

    const $product = $(this).closest('.product');
    const $form = $product.find('.productPairs .customAmountForm').first();

    if (!$form.length) return;

    const itemId = $form.find('input[name="itemId"]').val();

    if (itemId) {
        shoptet.cartShared.removeFromCart({ itemId }, true);
    }

    $form.attr({
        'data-item-id': '',
        'data-price-id': '',
        'data-current-amount': 0
    });

    $form.find('input[name="itemId"]').val('');
    $form.find('input[name="priceId"]').val('');
    $form.find('.amountInput').val(0);

    updateActiveState($form);
    updateProductPairsTotal($product.find('.productPairsList'));
    updateProductPairRemoveIcon($product);

    $product.find('.productPairs').slideUp();
    $product.find('.p-bottom').show();

    delayedCartSync(700);
});

function updateProductPairsVisibility($product) {
    const hasActive = $product
        .find('.productPairs .customAmountForm')
        .filter(function () {
            const amount = parseInt($(this).find('.amountInput').val(), 10) || 0;
            const itemId = $(this).find('input[name="itemId"]').val();

            return amount > 0 && !!itemId;
        }).length > 0;

    if (hasActive) {
        $product.find('.p-bottom').hide();
        $product.find('.productPairs').show();
    }
}

function showCartMessage(productElement, message, typeClass) {
    productElement.find('.cartMessage').remove();

    const $message = $('<div class="cartMessage"></div>')
        .text(message)
        .addClass(typeClass || '');

    productElement.append($message);

    setTimeout(() => $message.addClass('isVisible'), 10);

    setTimeout(function () {
        $message.removeClass('isVisible');
        setTimeout(() => $message.remove(), 300);
    }, 2500);
}

function delayedCartSync(delay = 500) {
    setTimeout(syncCustomCartFormsFromDataLayer, delay);
}

$(document).ready(function () {
    productMove();
    delayedCartSync(100);
});

[
    'ShoptetDOMPageContentLoaded',
    'ShoptetPageSortingChanged',
    'ShoptetDOMPageMoreProductsLoaded'
].forEach(eventName => {
    document.addEventListener(eventName, function () {
        productMove();
        delayedCartSync(100);
    });
});

[
    'ShoptetCartAddCartItem',
    'ShoptetCartUpdated',
    'ShoptetCartRemoveCartItem'
].forEach(eventName => {
    document.addEventListener(eventName, function () {
        delayedCartSync();
    });
});

document.addEventListener('dkLabFavouriteProductsLoaded', function () {
    productMove(2500);
    delayedCartSync(100);
});